import '../App.css';
import React, { Component, useEffect, useState } from 'react'
import { withAuthenticator } from '@aws-amplify/ui-react'
import { BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';
import Amplify, {Auth, API, graphqlOperation, Storage } from 'aws-amplify'
import Slide from './Slide.js'
import { createSlideshow, updateSlideshow, deleteSlideshow } from '../graphql/mutations'
import { listSlideshows } from '../graphql/queries'
import AddSlidePopup from './AddSlidePopup.js';

class EditSlideshows extends React.Component {
    
    constructor(){
        super();
        this.state = {
            loaded: false,
            isAuthenticated: false,
            title: "",
            new: false,
            seen: false
        }
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser()
        .then(() => {
            console.log(this.props.location.state.slides);
          this.setState({ 
              loaded: true, 
              isAuthenticated: true, 
              title: ( this.props.location.state.title !== "Create New Slideshow" ? this.props.location.state.title : "New Slideshow"),
              slides: this.props.location.state.slides,
              new: this.props.location.state.new,
              id: this.props.location.state.id
        })
        })
        .catch(() => this.props.history.push(''));
    }

    handleChange = e =>{
    
        e.preventDefault();
        switch(e.target.id){
          case "title":
            this.setState({title: e.target.value});
          
            break;
          case "file":
            const CopyArray = e.target.files;
            this.setState({
              file: CopyArray
            });
            console.log(this.state.file);
            break;
        }
        
    }

    handleClick = e => {
        switch(e.target.id){
            case "exitEditor":
                var r = window.confirm("If you leave this page without saving then your changes won't be saved");
                if (r == true) {
                    
                    console.log(e.target.id);
                    let path = 'user';// + e.target.id;
                    this.props.history.push(path)
                } 
                break;
            case "saveEditor":
                
                if(this.state.title === ""){
                    alert("ERROR - The title is blank");
                    return;
                }
                if(this.state.slides.length === 0){
                    alert("ERROR - There are no slides in this slideshow");
                    return;
                }
                if(this.state.new){
                    this.addSlideshow();
                }
                else{
                    this.modifySlideshow();
                }
                break;
        }
    }

    modifySlideshow = async(e) =>{
    
        try{
            const slideshowData = await API.graphql(graphqlOperation(listSlideshows));
            const slideshows = slideshowData.data.listSlideshows.items;

            for(var i = 0; i < slideshows.length; i++){
                console.log(slideshows[i].id + " vs " + this.state.id);
                if(slideshows[i].name == this.state.title && slideshows[i].owner == Auth.user.username && slideshows[i].id !== this.state.id){
                    alert("A Slideshow with that name already exists");
                    return;
                }
            }

            var titleTemp = this.state.title;
            while(titleTemp.search(" ") > 1){
                var index = titleTemp.indexOf(" ");
                
                //console.log(titleTemp.substr(0, index) + "+" + titleTemp.substr(index, titleTemp.length));
                titleTemp = titleTemp.substr(0, index) + "+" + titleTemp.substr(index+1, titleTemp.length);
            }
            const TempArray = Object.assign([], this.state.slides);
          
            const slideshow={
                name: this.state.title,
                owner: Auth.user.username,
                flies: TempArray,
                id: this.state.id
            }
            await API.graphql(graphqlOperation(updateSlideshow, {input: slideshow}));
            alert("Saved Successfully");
        }catch(err){
            console.log("error modifying slideshow:", err)
        }
    }

    removeSlideshow = async(e)=>{
        console.log("REMOVE");
        try{
            var r = window.confirm("Are you sure you want to DELETE your slideshow?");
            if (r == true) {
                
                
                const slideshow={
                    id: this.state.id
                }
                await API.graphql(graphqlOperation(deleteSlideshow, {input: slideshow}));
                alert("Deleted Successfully");
                
                let path = 'user';// + e.target.id;
                this.props.history.push(path)
            } 
            
        }catch(err){
            alert("Error Deleting Slideshow: " + err);
        }
    }

    addSlideshow = async(e) =>{
    
        try{
          const slideshowData = await API.graphql(graphqlOperation(listSlideshows));
          const slideshows = slideshowData.data.listSlideshows.items;
    
          for(var i = 0; i < slideshows.length; i++){
            console.log(slideshows[i].name + " vs " + this.state.title);
            if(slideshows[i].name == this.state.title && slideshows[i].owner == Auth.user.username){
              alert("A Slideshow with that name already exists");
              return;
            }
          }
    
          var titleTemp = this.state.title;
          while(titleTemp.search(" ") > 1){
            var index = titleTemp.indexOf(" ");
            
            //console.log(titleTemp.substr(0, index) + "+" + titleTemp.substr(index, titleTemp.length));
            titleTemp = titleTemp.substr(0, index) + "+" + titleTemp.substr(index+1, titleTemp.length);
          }
    
          const TempArray = Object.assign([], this.state.slides);
          
          const slideshow={
            name: this.state.title,
            owner: Auth.user.username,
            flies: TempArray,
            id: 4
          }
          await API.graphql(graphqlOperation(createSlideshow, {input: slideshow}));
          alert("Uploaded Successfully");
        }catch(err){
          console.log("error creating slideshow:", err)
        }
    }

    togglePop = () =>{
        console.log(this.state.seen)
        this.setState({
            seen: !this.state.seen
        });
    }

    addSlides = (array) =>{
        console.log("Added Slides " + array);
        const CopyArray = []; 
        for(var i = 0; i < this.state.slides.length; i++){
            console.log(this.state.slides[i]);
            CopyArray.push(this.state.slides[i]);
        }
        for(var i = 0; i < array.length; i++){
            CopyArray.push(array[i]);
        }

        this.setState({slides: CopyArray});
    }

    removeSlide = (e) =>{
        for(var i = 0; i < this.state.slides.length; i++){
            if(e.target.id === this.state.slides[i]){
                var a = this.state.slides[i];
                this.state.slides.splice(i + 1, 0);
                this.state.slides.splice(i, 1);
                this.state.slides.join();
                this.setState({
                    slides: this.state.slides
                })
                console.log(this.state.slides.length);
                return;
            }
        }  
    }

    moveSlide = (e) =>{
        switch(e.target.id){
            case "moveRight":
                for(var i = 0; i < this.state.slides.length; i++){
                    if(e.target.className === this.state.slides[i] && (i + 1) < this.state.slides.length){
                        console.log(this.state.slides.length);
                        var a = this.state.slides[i];
                        this.state.slides[i] = this.state.slides[i + 1];
                        this.state.slides[i + 1] = a;

                        this.setState({
                            slides: this.state.slides
                        })
                        return;
                    }
                }  
                break;
            case "moveLeft":
                for(var i = 0; i < this.state.slides.length; i++){
                    if(e.target.className === this.state.slides[i] && (i - 1) >= 0){
                        console.log(this.state.slides.length);
                        var a = this.state.slides[i];
                        this.state.slides[i] = this.state.slides[i - 1];
                        this.state.slides[i - 1] = a;

                        this.setState({
                            slides: this.state.slides
                        })
                        return;
                    }
                }  
                break;
        }
        console.log(e.target.className);
    }

    render(){
        
        const { router, params, location, routes } = this.props;
        const { loaded , isAuthenticated} = this.state
        if (!loaded) return null
        return(
            <html>
                {this.state.seen ? <AddSlidePopup toggle={this.togglePop} addSlides={this.addSlides}/> : null}
                <header className="EditorHeader">
                    <div id="Username">{Auth.user.username}</div>
                    <div className="EditorSlideshowTitle">
                    <input id="title" value={this.state.title} onChange={this.handleChange} type="text" required/>
                        </div>
                    <div className="EditorSlideshowButtons"> 
                        <button id="addSlides" onClick={this.togglePop}>Add Slide(s)</button>
                        <button id="deleteSlideshow" className="TrashBtn" onClick={this.removeSlideshow}></button> 
                        <button id="saveEditor" className="SaveBtn" onClick={this.handleClick}></button> 
                        <button id="exitEditor" className="ExitBtn" onClick={this.handleClick}></button>
                    </div>
                </header>
                <body id="EditorBody">
                    <ul id="SlideList">
                        {
                            this.state.slides.map((slides, index )=>{
                                return(
                                    <li id="Slides">
                                    {React.createElement(Slide, {move: this.moveSlide, remove: this.removeSlide, type: slides.substr(slides.length - 3, slides.length),src: slides, index: index})}
                                    </li>
                                )
                            })
                        }
                    </ul>
                </body>
            </html>
        )
    }
}

export default withRouter(EditSlideshows);